import React from "react";
import WavesBackground from "@/components/WavesBackground/WavesBackground";
import { ShieldLogo } from "@/components/ShieldLogo/ShieldLogo";
import { PromoCode } from "@/features/PromoCode/PromoCode";
import { ActionsBlock } from "./ActionsBlock";
import { SubscriptionBlock } from "./SubscriptionBlock";
import cls from "../styles.module.scss";

export function MainScreen() {
  return (
    <div className={cls.container}>
      <WavesBackground />

      <div className={cls.content}>
        <div className={cls.logoBlock}>
          <h1 className={cls.title}>БКоннект</h1>
          <p className={cls.subtitle}>Быстрое и надежное соединение</p>
        </div>

        <ShieldLogo />

        <div className={cls.subscriptionBlock}>
          <SubscriptionBlock />
        </div>

        <PromoCode />

        <ActionsBlock />
      </div>
    </div>
  );
}
